gsap.registerPlugin(ScrollTrigger);
// -------------------------------------------

// CONTEXT: HEADER ----------
// reveal header background on page scroll

const headerWrapper = document.querySelector(
  ".header-container .header-wrapper"
);

if (headerWrapper) {
  let ticking = false;
  window.addEventListener("scroll", () => {
    if (!ticking) {
      requestAnimationFrame(() => {
        addOrRemoveClassName();
        ticking = false;
      });
      ticking = true;
    }
  });
  function addOrRemoveClassName() {
    if (window.scrollY > 5) {
      headerWrapper.classList.add("scrolled");
    } else {
      headerWrapper.classList.remove("scrolled");
    }
  }
}

// CONTEXT: SECTION HEADING -----------
// Get all highlighted text from headings
// and animate when it comes into view

const highlightedTexts = document.querySelectorAll(
  ".--tilt-up-theme-text, .--tilt-down-theme-text"
);

if (highlightedTexts && highlightedTexts.length > 0) {
  highlightedTexts.forEach((text) => {
    gsap.set(text, { transform: "none", opacity: 0, width: 0, willChange: "transform, opacity, width" });
  });

  highlightedTexts.forEach((text) => {
    let shouldTiltUp = text.classList.contains("--tilt-up-theme-text");

    let tl = gsap.timeline({
      scrollTrigger: {
        trigger: text,
        start: "top 80%",
      }
    });
    tl.to(text, {
      opacity: 1,
      width: "auto",
      delay: 0.5,
    })
    tl.to(text, {
      rotate: shouldTiltUp ? 3 : -3,
    })
  });
}

// CONTEXT: SECTION HEADING -----------
// animate text in view

const sectionHeadingTexts = document.querySelectorAll(".large-heading");
if (sectionHeadingTexts && sectionHeadingTexts.length > 0) {
  gsap.set(sectionHeadingTexts, {opacity: 1});
  
  sectionHeadingTexts.forEach((textEl) => {
    const splitTextInstance = SplitText.create(textEl, { type: "words", mask: "words" });
    gsap.set(splitTextInstance.words, {
      yPercent: 100,
      opacity: 0
    });

    ScrollTrigger.create({
      trigger: textEl,
      start: "top 80%",
      animation: gsap.to(splitTextInstance.words, {
        yPercent: 0,
        opacity: 1,
        duration: 0.5,
        ease: "power1.inOut",
        stagger: 0.05,
      }),
    });
  });
}

// CONTEXT: HOME PAGE VIDEO ANIMATIONS -----------

const homeVideoEle = document.querySelector("[data-animate-video]");
if (homeVideoEle) {
  gsap.to(homeVideoEle, {
    width: "100%",
    aspectRatio: 16 / 9,
    borderRadius: "0px",
    scrollTrigger: {
      trigger: homeVideoEle,
      start: "top 60%",
      end: "+=200px",
      toggleActions: "play none reverse none",
      scrub: 1
    }
  });
}

// CONTEXT: VIDEO TESTIMONIAL SECTION -----------

const videoTestimonialCardWrapper = document.querySelector(
  ".video-testimonials-content"
);
const videoTestimonialWrapper = document.querySelector(
  ".video-testimonials-wrapper"
);

if (videoTestimonialCardWrapper) {
  gsap.set(videoTestimonialCardWrapper.children, {
    pointerEvents: "none"
  });

  gsap.set(videoTestimonialCardWrapper.querySelector(".card_1"), {
    xPercent: 140
  })
  gsap.set(videoTestimonialCardWrapper.querySelector(".card_2"), {
    xPercent: 40
  })
  gsap.set(videoTestimonialCardWrapper.querySelector(".card_3"), {
    xPercent: -60
  })
  gsap.set(videoTestimonialCardWrapper.querySelector(".card_4"), {
    xPercent: -160
  })



  gsap.to(videoTestimonialCardWrapper.children, {
    xPercent: 0,
    stagger: 0.05,
    duration: 0.8,
    scrollTrigger: {
      trigger: videoTestimonialCardWrapper,
      start: "top 60%"
    },
    onComplete: () => {
      gsap.set(videoTestimonialCardWrapper.children, {
        pointerEvents: "auto",
        transition: "transform 0.3s ease"
      });
    }
  });
}


// CONTEXT: PRODUCT HIGHLIGHTS SECTION -----------
const giantLogoWrapper = document.querySelector(".product-highlights__giant-logo");

if (giantLogoWrapper) {
  gsap.set(giantLogoWrapper, {
    scale: 0,
    opacity: 0,
    willChange: "transform, opacity",
    transformOrigin: "center"
  })

  gsap.to(giantLogoWrapper, {
    scale: 1,
    opacity: 1,
    duration: 1,
    scrollTrigger: {
      trigger: giantLogoWrapper,
      start: "top 60%"
    }
  })
}


// CONTEXT: FOOTER SECTION ----------------------------
const targetTextEl = document.querySelector(".target__footer-gsap-text");

if (targetTextEl) {
  const loopText = ["hygiene", "easy clean","freshness", "confidence"];
  let currentIndex = 0;

  function getResponsiveWidth(text) {
    // Add 0.5ch more if screen width is less than 578px
    return window.innerWidth < 578
      ? (text.length + 0.5) + "ch"
      : text.length + "ch";
  }

  function animateText() {
    // Split current text into characters
    const split = new SplitText(targetTextEl, { type: "chars" });

    // Animate characters out
    gsap.to(split.chars, {
      yPercent: 100,
      opacity: 0,
      stagger: 0.05,
      duration: 0.5,
      onComplete: () => {
        // Update text content
        gsap.to(targetTextEl, { width: getResponsiveWidth(loopText[currentIndex]) });
        targetTextEl.textContent = loopText[currentIndex];
        currentIndex = (currentIndex + 1) % loopText.length;

        // Re-split with new text
        const newSplit = new SplitText(targetTextEl, { type: "chars" });

        // Animate characters in
        gsap.fromTo(
          newSplit.chars,
          { yPercent: -100, opacity: 0 },
          {
            yPercent: 0,
            opacity: 1,
            stagger: 0.05,
            duration: 0.5,
            onComplete: () => {
              // Call again after delay
              gsap.delayedCall(1.5, animateText);
            }
          }
        );
      }
    });
  }

  ScrollTrigger.create({
    trigger: targetTextEl,
    start: "top 80%",
    once: true,
    onEnter: animateText
  }); 
}
